import { StompService, StompConfig, StompState } from '@stomp/ng2-stompjs';
import { Message } from '@stomp/stompjs';
import { Observable, BehaviorSubject } from 'rxjs';

export class MessagingService {
  private messages: Observable<Message>;
  private stompService: StompService;
  queue = '';

  private subscription: any;

  public notificationTopics = [];
  private notificationSubscriptions = {};

  constructor(socketUrl: string) {
    // Create Stomp Configuration
    const stompConfig: StompConfig = {
      url: socketUrl,
      headers: {
        login: '',
        passcode: ''
      },
      heartbeat_in: 0,
      heartbeat_out: 20000,
      reconnect_delay: 5000,
      debug: false
    };

    // Create Stomp Service
    this.stompService = new StompService(stompConfig);

    // Connect to a Stream
    // this.messages = this.stompService.subscribe(streamUrl);
  }

  public subscribe(streamUrl: string, queueName) {
    // if (this.queue !== queueName) {
    //   if (this.queue !== '') {
    //     this.unsubscribe();
    //   }
    //   this.messages = this.stompService.subscribe(streamUrl, {
    //     // 'durable': true,
    //     // 'auto-delete' : false,
    //     'x-queue-name': queueName
    //   });
    //   this.queue = queueName;
    // }

    // this.stompService.stompClient.unsubscribe()

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    const observable = new Observable(observer => {
      this.subscription =  this.stompService.stompClient.subscribe(streamUrl, (message) => {
        if (message.body) {
          const temp = JSON.parse(message.body);
          observer.next(message);
        }
      }, {
        // 'durable': true,
        // 'auto-delete' : false,
        'x-queue-name': queueName
      });
    });

    return observable;
  }

  public addNotificationsTopic(topics) {

    for (const topic of topics) {
      if (!this.notificationTopics.includes(topic)) {
        this.notificationTopics.push(topic);
      }
    }
    for (const key of Object.keys(this.notificationSubscriptions)) {
      this.notificationSubscriptions[key].unsubscribe();
    }

    if (this.notificationTopics.length > 0) {

      const observable = new Observable(observer => {

        for (const topicName of this.notificationTopics) {
          const streamUrl = '/topic/' + topicName + '.response';
          this.notificationSubscriptions[topicName] = this.stompService.stompClient.subscribe(streamUrl, (message) => {
            if (message.body) {
              const temp = JSON.parse(message.body);
              observer.next(message);
            }
          }, {
            // 'durable': true,
            // 'auto-delete' : false,
            'x-queue-name': topicName
          });
        }
      });
      return observable;
    } else {
      return new Observable();
    }
  }

  public notification(msg) {
  }

  public connectObservable() {
    return this.stompService.connectObservable;
  }

  public unsubscribe() {
    this.subscription.unsubscribe();
  }

  public stream(): Observable<Message> {
    return this.messages;
  }

  public send(url: string, message: any) {
    return this.stompService.publish(url, JSON.stringify(message));
  }

  public disconnect() {
    this.stompService.disconnect();
  }

  public isOpen() {
    return this.stompService.connected();
  }

  public state(): BehaviorSubject<StompState> {
    return this.stompService.state;
  }
}
